export default __webpack_public_path__ + "static/media/checkmark-big.a0a1e276.svg";